<template>
  <div class="back-btn">
    <div class="icon-back">
      <a @click="goBack()" style="cursor: pointer">
        <svg
          width="2em"
          height="2em"
          viewBox="0 0 16 16"
          class="bi bi-arrow-left-short"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"
          />
        </svg>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "Cardapios-SetaVoltar",

  methods: {
    goBack() {
      if(this.$route.name === 'Cardapios-Produtos'){
        this.$router.push({
          name: "Cardapios-Home",
          params: {
            nomeUrl: this.$route.params.nomeUrl
          }
        });
      }else
        this.$router.go(-1);
    }
  }
}
</script>